import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';

export interface CardAppointmentHeaderProps {
  avatarSrc?: string;
  avatarAlt: string;
  avatarType: EntityTypeEnum;
  name: string;
  href?: string;
}

export function CardAppointmentHeader({
  avatarSrc,
  avatarAlt,
  avatarType,
  name,
  href,
}: CardAppointmentHeaderProps) {
  const label = (
    <Typography variant={TypographyVariant.BODY_TEXT} className="text-green-500 font-bold">
      {name}
    </Typography>
  );

  const avatar = (
    <EntityAvatar
      src={avatarSrc}
      alt={avatarAlt}
      type={avatarType}
      width={56}
      height={56}
      className="rounded-lg"
    />
  );

  return (
    <div className="flex items-center gap-3">
      {href ? <Link prefetch={false} href={href}>{avatar}</Link> : avatar}
      {href
        ? (
            <Link prefetch={false} href={href} data-testid={DataTestIdEnum.APPOINTMENT_CARD_HEADER_ENTITY_LINK}>
              {label}
            </Link>
          )
        : (
            label
          )}
    </div>
  );
}
